module.exports = __webpack_public_path__ + "img/10_28.9edf1efa.png";